import React from 'react';
import { Search, X } from 'lucide-react';
import { getMonthName, getMonthAbbr } from '../utils/dateUtils';
import EventRow from '../components/EventRow';
import ScreenHeader from '../components/ScreenHeader';

export default function SearchScreen({
  searchQuery, setSearchQuery,
  allEvents,
  openEventDetailFromSearch,
  setCurrentScreen,
}) {
  const query = searchQuery.toLowerCase().trim();
  const filteredEvents = query
    ? allEvents.filter(e =>
        e.title.toLowerCase().includes(query) ||
        e.time.toLowerCase().includes(query) ||
        e.tags.some(t => t.toLowerCase().includes(query)) ||
        getMonthName(e.month).toLowerCase().includes(query) ||
        getMonthAbbr(e.month).toLowerCase().includes(query) ||
        `${getMonthName(e.month)} ${e.day}`.toLowerCase().includes(query) ||
        String(e.day).includes(query)
      )
    : allEvents.sort((a, b) => {
        const dateA = new Date(a.year, a.month - 1, a.day);
        const dateB = new Date(b.year, b.month - 1, b.day);
        return dateA - dateB;
      });

  return (
    <div className="h-full flex flex-col">
      <ScreenHeader
        title="Search Events"
        onBack={() => { setCurrentScreen('home'); setSearchQuery(''); }}
      >
        <div className="relative">
          <Search size={18} className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search events, dates, tags..."
            className="w-full border-2 border-gray-300 rounded-lg p-2.5 pl-10 pr-10 focus:border-blue-500 focus:outline-none text-sm"
            autoFocus
          />
          {searchQuery && (
            <button onClick={() => setSearchQuery('')} className="absolute right-3 top-2.5 p-0.5 hover:bg-gray-100 rounded">
              <X size={16} className="text-gray-400" />
            </button>
          )}
        </div>
      </ScreenHeader>

      <div className="flex-1 overflow-auto p-4">
        {query && (
          <div className="text-xs text-gray-500 mb-3">
            {filteredEvents.length} result{filteredEvents.length !== 1 ? 's' : ''}
          </div>
        )}
        {!query && (
          <div className="text-xs text-gray-500 mb-3">All events</div>
        )}
        <div className="space-y-2">
          {filteredEvents.map(event => (
            <EventRow key={event.id} event={event} onClick={() => openEventDetailFromSearch(event)} showDate />
          ))}
          {query && filteredEvents.length === 0 && (
            <div className="text-center py-8">
              <div className="text-gray-500 text-sm">No events match "{searchQuery}"</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
